class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('[role="tab"]');
        this.panes = this.querySelectorAll('[role="tabpanel"]');

        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('aria-controls');
                this.switchTab(button, targetId);
            });
        });
    }

    switchTab(selectedBtn, targetId) {
        this.buttons.forEach((btn) => {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-selected', 'false');
        });
        this.panes.forEach((pane) => pane.classList.remove('is-active'));

        selectedBtn.classList.add('is-active');
        selectedBtn.setAttribute('aria-selected', 'true');
        const targetPane = this.querySelector(`#${targetId}`);
        if (targetPane) targetPane.classList.add('is-active');
    }
}

customElements.define('product-tabs', ProductTabs);

function initProductInformationPositioning() {
    const sectionsToMove = document.querySelectorAll('.product-info-tabs[data-position="inside"]');
    const target = document.querySelector('.product__info-container');

    if (sectionsToMove.length > 0 && target) {
        sectionsToMove.forEach(section => {
            const sectionId = section.getAttribute('data-section-id');
            const existing = target.querySelector(`.product-info-tabs[data-section-id="${sectionId}"]`);
            if (existing && existing !== section) {
                existing.remove();
            }
            target.appendChild(section);
            section.classList.add('is-inside');
        });
    }
}

function initProductAccordionAutoClose() {
    const accordionContainers = document.querySelectorAll('.product-info-accordions');
    accordionContainers.forEach(container => {
        const details = container.querySelectorAll('details');
        details.forEach(item => {
            const summary = item.querySelector('summary');
            summary.addEventListener('click', (event) => {
                // If it's open and user clicks to close, we want to animate it
                if (item.hasAttribute('open')) {
                    event.preventDefault(); // Prevent immediate close
                    item.classList.add('is-closing');
                    setTimeout(() => {
                        item.removeAttribute('open');
                        item.classList.remove('is-closing');
                    }, 500); // Match CSS transition time
                } else {
                    // Opening: Close others first
                    details.forEach(otherItem => {
                        if (otherItem !== item && otherItem.hasAttribute('open')) {
                            otherItem.classList.add('is-closing');
                            setTimeout(() => {
                                otherItem.removeAttribute('open');
                                otherItem.classList.remove('is-closing');
                            }, 500);
                        }
                    });
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initProductInformationPositioning();
    initProductAccordionAutoClose();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        const sectionElement = event.target.querySelector('.product-info-tabs[data-position="inside"]');
        const target = document.querySelector('.product__info-container');
        if (sectionElement && target) {
            const sectionId = sectionElement.getAttribute('data-section-id');
            const existing = target.querySelector(`.product-info-tabs[data-section-id="${sectionId}"]`);
            if (existing) {
                existing.remove();
            }
            target.appendChild(sectionElement);
            sectionElement.classList.add('is-inside');
        }
        initProductAccordionAutoClose();
    });
}
